<template>
  <div class="evolution">
    <div
      v-for="(stat, index) in stats"
      :key="index"
      class="evolution__text"
      :class="evolutionNumberClass(stat)"
    >
      <i
        class="text__symbol icon-arrow-vs"
        :class="evolutionSymbolClass(stat)"
      />
      <!-- eslint-disable vue/no-v-html -->
      <p
        class="text__number"
        v-html="formatMemberValue(stat.evolution!, format, FormatContext.EVOLUTION, true)"
      />
      <!--eslint-enable-->
    </div>

    <p class="evolution__comparison">
      {{ $t('dashboard.stats.vs') }}
      {{ $t(`dashboard.stats.${periodType}`) }}
    </p>
  </div>
</template>

<script lang="ts">
import { type Stat } from '~/types/analytics'
import { PeriodType } from '~/types/timeDimension'
import { formatMemberValue } from '~/services/analyticsFormat'
import { FormatContext, MemberFormat } from '~/types/analyticsFormat'

export default {
  name: 'ReflectEvolution',
  props: {
    stats: {
      type: Array as PropType<Stat[]>,
      default: () => []
    },
    format: {
      type: String as PropType<MemberFormat>,
      required: true
    },
    isFavorable: {
      type: Boolean,
      default: undefined
    },
    periodType: {
      type: String as PropType<PeriodType>,
      default: undefined
    }
  },
  setup() {
    return { formatMemberValue, FormatContext }
  },
  methods: {
    evolutionNumberClass(stat: Stat) {
      if (this.isFavorable === null) {
        return 'evolution__text--none'
      } else if (this.isFavorable) {
        return stat.evolution !== 0
          ? stat.evolution! > 0
            ? 'evolution__text--good'
            : 'evolution__text--bad'
          : 'evolution__text--none'
      } else {
        return stat.evolution !== 0
          ? stat.evolution! > 0
            ? 'evolution__text--bad'
            : 'evolution__text--good'
          : 'evolution__text--none'
      }
    },
    evolutionSymbolClass(stat: Stat) {
      return [
        stat.evolution === 0 && 'text__symbol--mid',
        stat.evolution! < 0 && 'text__symbol--down',
        stat.evolution! > 0 && 'text__symbol--up'
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.evolution {
  display: flex;
  margin-top: 1px;

  &__text {
    display: flex;
    flex: none;
    align-self: flex-start;
    @include font-text;
    @include font-size($font-size-regular);
    margin-right: 4px;

    &--good {
      color: $color-favorable;
    }

    &--bad {
      color: $color-unfavorable;
    }

    &--none {
      color: $text-primary;
    }

    .text {
      &__number {
        :deep(.medium) {
          @include font-size(13px);
        }

        :deep(.small) {
          @include font-size(13px);
        }
      }

      &__symbol {
        $symbol-size: 16px;
        flex: none;
        @include font-icon;
        @include font-size($symbol-size, $symbol-size);
        width: $symbol-size;
        height: $symbol-size;
        transform-origin: center;
        margin-top: 2px;

        &--down {
          transform: rotate(90deg);
        }

        &--up {
          transform: rotate(-90deg);
        }

        &--mid {
          transform: rotate(0deg);
          margin-top: 3px;
          margin-right: 2px;
        }
      }
    }
  }

  &__comparison {
    display: inline;
    white-space: nowrap;
    @include font-text;
    @include font-size($font-size-mini);
    color: $text-tertiary;
    margin-top: 3px;
  }
}
</style>
